import { LOADER } from "../definitions";

const initialStates = {
  isLoading: false,
};

const loaderReducer = (state = initialStates, action) => {
  switch (action.type) {
    case LOADER.START_LOADER: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case LOADER.END_LOADER: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    default:
      return state;
  }
};

export { loaderReducer };
